import { useCallback, useEffect, useState } from 'react';

import { PlayerVideoRef } from '../PlayerVideo.types';

const UPDATE_CURRENT_TIME_INTERVAL = 1000; /** 1 second */

interface UseCurrentTimeInSecondsProps {
  playerVideoRef?: React.RefObject<PlayerVideoRef | null>;
  updateCurrentTimeInterval?: number;
}

interface UseCurrentTimeInSecondsResponse {
  currentTime: number /** seconds */;
  updateTime: () => void;
}

export default ({
  playerVideoRef,
  updateCurrentTimeInterval = UPDATE_CURRENT_TIME_INTERVAL,
}: UseCurrentTimeInSecondsProps): UseCurrentTimeInSecondsResponse => {
  const [currentTime, setCurrentTime] = useState(-1);

  const updateTime = useCallback(() => {
    setCurrentTime(playerVideoRef?.current?.getCurrentTimeInSeconds() ?? -1);
  }, [playerVideoRef]);

  useEffect(() => {
    const pid = setInterval(() => {
      updateTime();
    }, updateCurrentTimeInterval);

    return () => {
      clearInterval(pid);
    };
  }, [updateCurrentTimeInterval, updateTime]);

  return { currentTime, updateTime };
};
